/* @flow */

import React from 'react';
import { Popup, Button } from 'semantic-ui-react';

type Props = {
  upload: RunningUpload,
};

const styles = {
  loader: {
    paddingTop: '0.8em',
    paddingLeft: '0.3em',
  },
};

const textFromState = state => {
  switch (state) {
    case 'uploading':
      return 'Envoi';
    case 'processing':
      return 'Traitement';
    default:
      console.warn(`Unknown upload state ${state}`);
      return '';
  }
};

const errorContent = error => {
  if (error && error.res) {
    switch (error.res.status) {
      case 408:
      case 504:
        return 'Problème réseau. Vérifiez votre connexion';
      case 413:
        return 'Fichier trop volumineux (> 150 Mo)';
      case 502:
      case 503:
        return 'Serveur indisponible';
      default:
        return 'Une erreur technique est survenue';
    }
  }

  return 'Une erreur serveur est survenue';
};

const UploadItemState = ({ upload }: Props) => {
  switch (upload.state) {
    case 'uploading':
    case 'processing':
      return (
        <button className="ui tiny right floated labeled icon button">
          <i className="icon" style={styles.loader}>
            <i className="notched circle loading icon" />
          </i>
          {textFromState(upload.state)}
        </button>
      );
    case 'error':
      return (
        <Popup
          trigger={
            <Button
              icon="warning"
              size="tiny"
              inverted
              floated="right"
              color="red"
            />
          }
          content={errorContent(upload.error)}
          positioning="left center"
        />
      );
    default:
      return null;
  }
};

export default UploadItemState;



// WEBPACK FOOTER //
// ./src/modules/bucket/screens/Upload/components/UploadItemState.js